const toStringValue = (value: unknown): string => {
  if (typeof value === "string") {
    return value;
  }
  if (value == null) {
    return "";
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
};

export const normalizeString = (value: unknown): string => {
  if (typeof value === "string") {
    return value.trim().replace(/\s+/g, " ");
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
};

export const normalizeStringWithFallback = (value: unknown, fallback = ""): string => {
  if (typeof value !== "string") {
    return fallback;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : fallback;
};

export const toNullableStringValue = (value: unknown): string | null => {
  return typeof value === "string" ? value : null;
};

export const toOptionalString = (value: unknown): string | undefined => {
  const trimmed = normalizeStringWithFallback(value, "");
  return trimmed.length > 0 ? trimmed : undefined;
};

export const toTrimmedString = (value: unknown): string => {
  return toStringValue(value).trim();
};

export const toNullableTrimmedString = (value: unknown): string | null => {
  const trimmed = toTrimmedString(value);
  return trimmed.length > 0 ? trimmed : null;
};

export const toOptionalTrimmedString = (value: unknown): string | undefined => {
  const trimmed = toTrimmedString(value);
  return trimmed.length > 0 ? trimmed : undefined;
};

export const normalizeNullableString = (value: unknown): string | null => {
  return toNullableTrimmedString(value);
};

export const normalizeStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map(entry => toTrimmedString(entry)).filter(entry => entry.length > 0);
};
